import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./App.css";
import AppLayout from "./layout/layout";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import LoginPage from "./views/login/login";
import { Provider } from "react-redux";
import store, { persistor } from "./context/store";
import { PersistGate } from "redux-persist/integration/react";
function App() {
    return (_jsx(Provider, { store: store, children: _jsx(PersistGate, { loading: null, persistor: persistor, children: _jsx(Router, { children: _jsx(ConfigProvider, { theme: {
                        token: {
                            colorPrimary: '#00A4A4',
                            colorLink: '#00A4A4',
                            // colorError: '#00A4A4', 
                            colorText: '#43485F',
                            fontSize: 12,
                            // fontSizeLG: 14
                        },
                        components: {
                            Menu: {
                                darkItemBg: '#ffffff',
                                darkItemColor: '#43485F',
                                darkItemHoverColor: '#43485F',
                                darkItemSelectedBg: '#00A4A4',
                                itemHoverColor: '#00A4A4',
                                itemColor: '#ffffff',
                                popupBg: '#43485F',
                            },
                            Tag: {
                                defaultBg: '#ffffff',
                                defaultColor: '#00A4A4',
                            },
                            Table: {
                                headerBg: '#F4F4FB',
                                stickyScrollBarBorderRadius: 0,
                                borderColor: '#CBCEDA',
                            },
                            Pagination: {
                                itemSizeSM: 32
                            },
                            Descriptions: {
                                labelBg: '#F4F4FB',
                            },
                            Form: {
                                itemMarginBottom: 22
                            },
                            Segmented: {
                                itemSelectedBg: '#00A4A4',
                                itemSelectedColor: '#ffffff',
                            },
                            Layout: {
                                headerHeight: 40,
                                footerPadding: "10px 10px",
                            }
                        },
                    }, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/*", element: _jsx(AppLayout, {}) })] }) }) }) }) }));
}
export default App;
